import { RouteSheet } from '@/components/route-sheet';
import { useGetMatchedRoute } from '@/hooks/routing';
import { useI18n } from '@nosinovacao/nosid-mfe-common';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(home)/home/(change-contacts)/_sheet')({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useI18n();
  const navigate = Route.useNavigate();
  const match = useGetMatchedRoute();
  let hasBack = false;
  let title = '';
  let subtitle: string | undefined;
  switch (match.routeId) {
    case '/(home)/home/(change-contacts)/_sheet/change-contacts/(landing-page)/':
      hasBack = false;
      title = t('Home.ChangeContacts.LandingPage.Title');
      break;
    case '/(home)/home/(change-contacts)/_sheet/change-contacts/new-contact/':
      hasBack = true;
      title = t(
        (match.loaderData as { type: 'phone' | 'email' } | undefined)?.type === 'email'
          ? 'Home.ChangeContacts.NewContact.Title.Email'
          : 'Home.ChangeContacts.NewContact.Title.Phone',
      );
      break;
    case '/(home)/home/(change-contacts)/_sheet/change-contacts/code-input/': {
      hasBack = true;
      title = t('Home.ChangeContacts.ValidateCode.Title');
      const loaderData = match.loaderData as
        | { type: 'phone' | 'email'; contact: string }
        | undefined;
      const descKey =
        loaderData?.type === 'phone'
          ? 'Home.ChangeContacts.ValidateCode.Description.Phone'
          : 'Home.ChangeContacts.ValidateCode.Description.Email';
      subtitle = t(descKey, { contact: loaderData?.contact });
      break;
    }
    case '/(home)/home/(change-contacts)/_sheet/change-contacts/username/':
      hasBack = true;
      title = t('Home.ChangeContacts.Username.Title');
      break;
  }

  return (
    <RouteSheet onClose={() => navigate({ to: '/home' })} options={{ hasBack, title, subtitle }} />
  );
}
